import React from 'react';
import StoreProvider from '../StoreProvider';
import PersistProvider from '../PresistProvider';
import I18nProvider from '../I18nProvider';
import AppRouter from '../AppRouter';
import GlobalMessage from '../../ui/GlobalMessage';
import {GlobalMessageContextProvider} from '../GlobalMessageContext';
import {GlobalContextProvider} from '../GlobalContext';

function App() {
  return (
    <StoreProvider>
      <PersistProvider>
        <I18nProvider>
          <GlobalMessageContextProvider>
            <GlobalContextProvider>
              <AppRouter/>
              <GlobalMessage/>
            </GlobalContextProvider>
          </GlobalMessageContextProvider>
        </I18nProvider>
      </PersistProvider>
    </StoreProvider>
  );
}

export default App;
